import React from "react";
import { Navigate, useParams } from "react-router-dom";

/** Legacy route removed; POS workspaces live under `/customer/dsok/pos/workspaces`. */
function RedirectCustomerDetailWorkspacesToOverview() {
  const { customerUrl } = useParams();
  return (
    <Navigate to={`/dsok/customer-detail/${customerUrl}`} replace />
  );
}

export const dsokCustomerWorkspacesRoute = {
  path: "/dsok/customer-detail/:customerUrl/workspaces",
  element: <RedirectCustomerDetailWorkspacesToOverview />,
};
